// Тема на приложението (цвят + светла/тъмна). Изборът е на КОМПЮТЪРА, не на
// човека: пази се в localStorage под ключ с името на ресторанта
// (`app_theme:<ресторант>`) и важи за всеки, който работи на това устройство —
// и на входа, и на ПИН екрана, и след вход. Така на един компютър може да е
// „Червено“, на друг „Небесно синьо“, независимо кой влиза. Сменя се само
// отвътре — профилното меню и бутонът на ПИН екрана (ThemeModal).
// Прилага се като класове върху <html>: "dark" за всяка тъмна (всички тъмни
// стойности в index.css са под .dark, а antd минава на darkAlgorithm от
// ThemedConfig) и "palette-<цвят>" / "palette-<цвят>-dark" за цветовете извън
// оранжевия (styles/palettes/<цвят>.css); оранжевият е базата и няма свой клас.
import type { ThemeMode } from "../api/configuration";
import { getRestaurantName } from "./restaurant";
import { THEME_PALETTES, themePaletteOf } from "./themePalettes";

export type { ThemeMode };

export function applyThemeMode(mode: ThemeMode): void {
  const root = document.documentElement;
  root.classList.toggle("dark", themePaletteOf(mode).isDark);
  for (const palette of THEME_PALETTES) {
    if (palette.paletteClass) {
      root.classList.toggle(palette.paletteClass, palette.mode === mode);
    }
  }
}

// С името на ресторанта: на localhost (и при голо IP) всички ресторанти делят
// един origin, тоест един localStorage.
const deviceThemeKey = () => `app_theme:${getRestaurantName()}`;

/** Темата, записана на този компютър; null — още не е избирана тук (или
 *  стойността е непозната, или storage-ът е недостъпен). */
export function readDeviceTheme(): ThemeMode | null {
  try {
    const stored = localStorage.getItem(deviceThemeKey());
    return THEME_PALETTES.find((palette) => palette.mode === stored)?.mode ?? null;
  } catch {
    return null;
  }
}

export function saveDeviceTheme(mode: ThemeMode): void {
  try {
    localStorage.setItem(deviceThemeKey(), mode);
  } catch {
    /* storage недостъпен — темата важи до презареждане */
  }
}
